import React from 'react';

interface ScopeBadgeProps {
  children: React.ReactNode;
  variant?: 'emerald' | 'slate' | 'outline';
  size?: 'sm' | 'xs';
  icon?: React.ReactNode;
  className?: string;
}

const ScopeBadge: React.FC<ScopeBadgeProps> = ({
  children,
  variant = 'outline',
  size = 'sm',
  icon,
  className = ''
}) => {
  const baseClasses = 'inline-flex items-center gap-1 rounded-full font-medium';

  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    xs: 'px-1.5 py-0.5 text-[10px]'
  };

  const variantClasses = {
    emerald: 'bg-emerald-100 text-emerald-700 border border-emerald-200',
    slate: 'bg-slate-100 text-slate-700 border border-slate-200',
    outline: 'bg-white text-gray-700 border border-gray-300'
  };

  return (
    <span className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${className}`}>
      {icon && <span className="flex-shrink-0">{icon}</span>}
      {children}
    </span>
  );
};

export default ScopeBadge;
